export const formatMultilinesText = (html: string) => {
  if (!html) return "";
  return html
    .replace(/<p>/g, "")
    .replace(/<\/p>/g, "")
    .replace(/<br>\n/g, "<br>")
    .replace(/(?:\r\n|\r|\n)/g, "<br>");
};
